import React, { useCallback, useEffect, useRef } from 'react';
import { useStyles } from './DibsIframeWrapper.styles';
import { getAppConfiguration } from '../../Config';
import { Box } from '@mui/material';
const postscribe = require('postscribe');
export const DibsIframeWrapper = (props) => {
    const classes = useStyles();
    const dibsSession = useRef(null);
    const openDibsView = useCallback(() => {
        var checkoutOptions = {
            checkoutKey: getAppConfiguration().dibsCheckoutKey,
            paymentId: props.paymentId,
            containerId: 'payment',
            language: 'sv-SE',
            theme: {
                textColor: 'rgba(0, 0, 0, 0.87)',
                linkColor: '#D87001',
                panelTextColor: 'rgba(0, 0, 0, 0.87)',
                panelLinkColor: '#D87001',
                primaryColor: '#06A771',
                buttonRadius: '5px',
                buttonTextColor: '#fff',
                backgroundColor: '#FFF',
                panelColor: '#FFF',
                outlineColor: 'rgba(224, 224, 224)',
                primaryOutlineColor: '#444', //sets the border color for radio buttons and checkboxes
            },
        };
        if (!dibsSession.current) {
            // @ts-ignore
            dibsSession.current = new Dibs.Checkout(checkoutOptions);
            dibsSession.current.on('payment-completed', props.onCompleted);
        }
    }, [props.paymentId, props.onCompleted]);
    useEffect(() => {
        postscribe('#payment', `<script
            src="${getAppConfiguration().dibsCheckoutJsUrl}"></script>`, {
            done: openDibsView,
            error: () => { },
        });
    }, [openDibsView]);
    return (React.createElement(Box, { component: "div", sx: classes.paymentWrapper },
        React.createElement(Box, { component: "div", sx: { marginTop: '-78px' } },
            React.createElement(Box, { component: "div", id: "payment" }))));
};
